import { facultyMembersRoutesObj, facultyMembersBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";
import { createRoute } from "@/routes/utils";

const permission = [IRole.STAFF, IRole.SUPER_ADMIN, IRole.DEPARTMENT_STAFF];

export const facultyMemberRouteMetadata: IRouteMetadataObj<
  typeof facultyMembersRoutesObj
> = {
  list: {
    title: "facultyMemberManagement",
    lazy: () =>
      import("@/pages/adminPanel/usersManagement/facultyMembers/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewFacultyMember",
    lazy: () =>
      import("@/pages/adminPanel/usersManagement/facultyMembers/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editFacultyMemberOf",
    lazy: () =>
      import("@/pages/adminPanel/usersManagement/facultyMembers/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewFacultyMemberOf",
    lazy: () =>
      import("@/pages/adminPanel/usersManagement/facultyMembers/form/page"),
    mode: "view",
    permission,
  },
};

export const facultyMembersRoutes = createRoute<typeof facultyMembersRoutesObj>(
  facultyMembersRoutesObj,
  facultyMemberRouteMetadata,
  facultyMembersBreadcrumbs,
);
